/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useLoanExpectedPaymentsGet = makeQueryHook(
  operations.loanExpectedPaymentsGet,
)

export const useLoanChangeDueDatesSchedulePost = makeMutationHook(
  operations.loanChangeDueDatesSchedulePost,
)

export const useDrawExpectedPaymentsGet = makeQueryHook(
  operations.drawExpectedPaymentsGet,
)

export const useDeferRemainingLocBalances = makeMutationHook(
  operations.deferRemainingLocBalances,
)

export const useDeferRemainingDrawBalances = makeMutationHook(
  operations.deferRemainingDrawBalances,
)

export const useLoanExpectedPaymentsRefresh = makeMutationHook(
  operations.loanExpectedPaymentsRefresh,
)

export const useInternalLoanExpectedPaymentsGet = makeQueryHook(
  operations.internalLoanExpectedPaymentsGet,
)

export const useInternalLoanChangeDueDatesSchedulePost = makeMutationHook(
  operations.internalLoanChangeDueDatesSchedulePost,
)

export const useInternalLoanExpectedPaymentsGetOne = makeQueryHook(
  operations.internalLoanExpectedPaymentsGetOne,
)

export const useInternalLoanExpectedPaymentsRefresh = makeMutationHook(
  operations.internalLoanExpectedPaymentsRefresh,
)

export const useInternalLoanExpectedPaymentOverride = makeMutationHook(
  operations.internalLoanExpectedPaymentOverride,
)

export const useInternalLoanExpectedPaymentsOverLimit = makeMutationHook(
  operations.internalLoanExpectedPaymentsOverLimit,
)

export const useInternalDeferRemainingLocBalances = makeMutationHook(
  operations.internalDeferRemainingLocBalances,
)
